// Central place for app/site-level constants.
// For Create React App, only env vars prefixed with REACT_APP_ are exposed to the browser.

export const SITE_NAME = process.env.REACT_APP_SITE_NAME || "YKOP";
